export default __webpack_public_path__ + "static/media/fNeutral4.fc385bce.png";